import { supabaseClient } from "./supabase";

export const e2ePaymentEndpoint = import.meta.env
  .VITE_E2E_PAYMENT_ENDPOINT_URL as string | undefined;

export const invokeE2EPayment = async (
  path: string,
  init: RequestInit = {},
) => {
  if (!e2ePaymentEndpoint) throw new Error("E2E payment endpoint is disabled");

  const { data } = await supabaseClient.auth.getSession();
  const accessToken = data.session?.access_token;
  if (!accessToken) throw new Error("The E2E payment request is not authenticated");

  const response = await fetch(`${e2ePaymentEndpoint}${path}`, {
    ...init,
    headers: {
      authorization: `Bearer ${accessToken}`,
      "content-type": "application/json",
      ...init.headers,
    },
  });
  const body = await response.json();
  if (!response.ok) throw new Error(body.error ?? "E2E payment request failed");
  return body;
};
